import dayjs from 'dayjs';

import formatDate from '@/utils/formatDate';

export const calculateAge = (birthDate: string): number => {
  const today = dayjs();
  const birth = dayjs(birthDate);

  if (!birth.isValid()) return 0;

  let age = today.year() - birth.year();

  // Adjust age if birthday hasn't occurred this year
  if (
    today.month() < birth.month() ||
    (today.month() === birth.month() && today.date() < birth.date())
  ) {
    age--;
  }

  return Math.max(0, age);
};

export const formatDateWithAge = (birthDate: string, format: string = 'MM/DD/YYYY'): string => {
  if (!birthDate) return '';

  const formattedDate = formatDate(birthDate, format);
  const age = calculateAge(birthDate);

  return formattedDate ? `${formattedDate} (${age} Years)` : '';
};

export const sexOptions = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
  { label: 'Other', value: 'other' },
  { label: 'Unknown', value: 'unknown' },
  { label: 'Ambiguous', value: 'ambiguous' },
  { label: 'Not applicable', value: 'not_applicable' },
  { label: 'Non-Binary', value: 'non_binary' }
];

export const formatTransmissionDate = (date: string) => {
  // Check for null/undefined and validate length of date
  if (!date || date.length < 8) return '';

  // Remove 'T' if present
  const cleanDate = date.replace('T', '');

  // Extract year, month, and day
  const year = cleanDate.substring(0, 4);
  const month = cleanDate.substring(4, 6);
  const day = cleanDate.substring(6, 8);

  // Extract hours and minutes, defaulting to '00' if not present
  const hours = cleanDate.length >= 10 ? cleanDate.substring(8, 10) : '00';
  const minutes = cleanDate.length >= 12 ? cleanDate.substring(10, 12) : '00';

  // Create a Date object
  const dateObj = new Date(
    Date.UTC(
      parseInt(year, 10),
      parseInt(month, 10) - 1, // Month is zero-based
      parseInt(day, 10),
      parseInt(hours, 10),
      parseInt(minutes, 10),
      0
    )
  );

  // Get parts
  let hour = dateObj.getUTCHours();
  const minute = dateObj.getUTCMinutes();
  const ampm = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  hour = hour ? hour : 12; // 0 becomes 12
  const paddedMinute = minute < 10 ? `0${minute}` : minute;

  // Format MM-DD-YYYY
  const formattedMonth = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
  const formattedDay = dateObj.getUTCDate().toString().padStart(2, '0');
  const formattedYear = dateObj.getUTCFullYear();

  return `${formattedMonth}-${formattedDay}-${formattedYear} ${hour}:${paddedMinute} ${ampm}`;
};
